export default __webpack_public_path__ + "images/C7.80f1d28.png";